"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Ticket = (function () {
    function Ticket(ticketOptions) {
        this.ticketOptions = ticketOptions;
    }
    Ticket.prototype.getJSON = function () {
        var json = {
            'SessionID': window['customLoggedIn'] && window['customToken'] ? window['customToken'] : window['token'],
            'TicketAmount': parseFloat(this.ticketOptions.getAmount()) * parseInt(this.ticketOptions.getSubscriptions()),
            'DrawsCount': this.ticketOptions.getSubscriptions(),
            'SelectedNumbers': this.ticketOptions.getChosenBalls().getBalls(),
            'First5Sum': this.ticketOptions.getFirst5Sum(),
            'BallParity': this.ticketOptions.getBallParity(),
            'BallSum': 0,
            'FirstBallParity': this.ticketOptions.getFirstBallParity(),
            'FirstballSum': this.ticketOptions.getFirstBallSum(),
            'LastBallParity': this.ticketOptions.getLastBallParity(),
            'LastBallSum': this.ticketOptions.getLastBallSum(),
            'TopColor': this.ticketOptions.getTopColor(),
            'FirstColor': this.ticketOptions.getFirstBallColor(),
            'LastColor': this.ticketOptions.getLastBallColor()
        };
        return json;
    };
    return Ticket;
}());
exports.default = Ticket;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/tickets/ticket.ts
// module id = 1205
// module chunks = 0